// Everything a visitor reads lives here, so copy edits never touch layout code.
import photo from './assets/davie-lee.jpg'
import tailwindShot from './assets/projects/tailwind.jpg'
import opennotaShot from './assets/projects/opennota.jpg'
import govanswersShot from './assets/projects/govanswers.jpg'
import intervalShot from './assets/projects/interval.jpg'
import cashflowCanvasShot from './assets/projects/cashflowcanvas.jpg'
import townfolioTeam from './assets/projects/townfolio-team.jpg'
import tailwindLogo from './assets/tailwind-transparent.png'
import opennotaLogo from './assets/opennota.png'
import govanswersLogo from './assets/govanswers.png'
import cashflowCanvasLogo from './assets/cashflowcanvas.png'
import psychologyOfMoney from './assets/covers/psychology-of-money.jpg'
import catchAndKill from './assets/covers/catch-and-kill.jpg'
import betaRayBill from './assets/covers/beta-ray-bill.jpg'
import vagabond from './assets/covers/vagabond.jpg'
import valleyOfGenius from './assets/covers/valley-of-genius.jpg'
import murderFalcon from './assets/covers/murder-falcon.jpg'
import badBlood from './assets/covers/bad-blood.jpg'
import descender from './assets/covers/descender.jpg'
import townfolioLogo from './assets/townfolio_logo.jpeg'
import intervalLogo from './assets/interVal.png'

export const profile = {
  name: 'Davie Lee',
  greeting: "Hello, I'm Davie.",
  subGreeting: 'Nice to e-meet you.',
  lede: "Walk with me through a tiny level: what I'm building right now, and what I'm into.",
  photo,
  linkedin: 'https://www.linkedin.com/in/davielee/',
}

// One chapter per enemy, in the order Davie fights them.
// `icon` names a pixel icon in game/sprites.js.
export const chapters = [
  {
    key: 'tailwind',
    icon: 'builder',
    quest: 'Main quest',
    label: 'Tailwind Research',
    title: 'Building Tailwind Research.',
    body: "My new company. We help college presidents and their leadership teams steer their campuses through AI, backed by our own data on what's working: AI policies, real use cases and best practices from schools across the map.",
    media: { type: 'shot', src: tailwindShot, logo: tailwindLogo, logoOnDark: true, url: 'https://teamtailwind.com', domain: 'teamtailwind.com' },
  },
  {
    key: 'interval',
    icon: 'invest',
    quest: 'Ally',
    label: 'interVal',
    title: 'Backing interVal.',
    body: "I'm an angel investor in interVal, which uses AI to produce valuations for business owners at scale, and I help the team build out their internal AI systems.",
    media: { type: 'shot', src: intervalShot, logo: intervalLogo, url: 'https://www.inter-val.ai', domain: 'inter-val.ai' },
  },
  {
    key: 'opennota',
    icon: 'nota',
    quest: 'Side quest',
    label: 'OpenNota',
    title: 'Every public discipline decision, in one place.',
    body: 'Discipline decisions for physicians, nurses, lawyers, teachers and more across Canada and the U.S., with plain-language summaries and a link to every original document.',
    media: { type: 'shot', src: opennotaShot, logo: opennotaLogo, url: 'https://opennota.com', domain: 'opennota.com' },
  },
  {
    key: 'govanswers',
    icon: 'gov',
    quest: 'Side quest',
    label: 'GovAnswers',
    title: 'Local laws, finally answerable.',
    body: 'Municipal bylaws, ordinances and policies from thousands of communities across Canada and the U.S., verified against the originals and published for people and AI agents alike.',
    media: { type: 'shot', src: govanswersShot, logo: govanswersLogo, url: 'https://govanswers.org', domain: 'govanswers.org' },
  },
  {
    key: 'glinda',
    icon: 'wand',
    quest: 'Side quest',
    label: 'Glinda',
    title: 'Glinda, an AI guide to the numbers.',
    body: 'Glinda powers The Cashflow Canvas, walking small business owners step by step through building their financial forecasts with AI. No jargon, no judgement, just clarity.',
    media: { type: 'shot', src: cashflowCanvasShot, logo: cashflowCanvasLogo, url: 'https://www.cashflowcanvas.com', domain: 'cashflowcanvas.com' },
  },
  {
    key: 'townfolio',
    icon: 'trophy',
    quest: 'Quest complete',
    label: 'Townfolio',
    title: 'Townfolio: quest complete.',
    body: 'Townfolio built economic development dashboards for municipalities. I ran it for five years, then sold it to a private equity firm.',
    media: { type: 'photo', src: townfolioTeam, logo: townfolioLogo, caption: 'The Townfolio team' },
  },
  {
    key: 'hobbies',
    icon: 'boxing',
    quest: 'Hobbies',
    label: 'Boxing & books',
    title: 'Gloves on, then a good book.',
    body: 'Boxing keeps me honest and non-fiction keeps me curious. My favourite reads so far:',
    media: {
      type: 'covers',
      items: [
        { src: psychologyOfMoney, title: 'The Psychology of Money', author: 'Morgan Housel' },
        { src: catchAndKill, title: 'Catch and Kill', author: 'Ronan Farrow' },
        { src: valleyOfGenius, title: 'Valley of Genius', author: 'Adam Fisher' },
        { src: badBlood, title: 'Bad Blood', author: 'John Carreyrou' },
      ],
    },
  },
  {
    key: 'stories',
    icon: 'comics',
    quest: 'Hobbies',
    label: 'Comics & manga',
    title: 'Stories with psychological depth.',
    body: 'I love comics that dig into who their characters really are. The ones I keep coming back to:',
    media: {
      type: 'covers',
      items: [
        { src: betaRayBill, title: 'Beta Ray Bill', author: 'Daniel Warren Johnson' },
        { src: murderFalcon, title: 'Murder Falcon', author: 'Daniel Warren Johnson' },
        { src: vagabond, title: 'Vagabond', author: 'Takehiko Inoue' },
        { src: descender, title: 'Descender', author: 'Jeff Lemire' },
      ],
    },
  },
]
